import PropTypes from "prop-types"
import React, { useCallback, useEffect, useState } from "react"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import withRouter from "../Common/withRouter"
import { Link, useLocation, useNavigate } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"
import { createSelector } from "reselect"
import { useSelector } from "react-redux"
import SkeletonLoading from "./SkeletonLoader"
import DashboardIcon from "../../assets/icons/iconComponents/dashboardIcon"
import ProductMasterIcon from "../../assets/icons/iconComponents/productMasterIcon"
import EstimateIcon from "../../assets/icons/iconComponents/estimateIcon"
import ProjectManagementIcon from "../../assets/icons/iconComponents/projectManagementIcon"
import LogoutIcon from "../../assets/icons/iconComponents/logOutIcon"
import ProcurementIcon from "../../assets/icons/iconComponents/procurementIcon"
import HrmsIcon from "../../assets/icons/iconComponents/hrmsIcon"
import SettingsIcon from "../../assets/icons/iconComponents/settingsIcon"
import FinanceIcon from "../../assets/icons/iconComponents/financeIcon"

// --- per-module sidebar drill-down helpers --------------------------------
// Find the module a route belongs to: the module whose landing path or any
// descendant leaf path best-matches the pathname (longest match wins, so
// e.g. /finance-ledger maps to Finance and not a shorter sibling).
const findActiveModule = (modules, pathname) => {
  let best = null
  let bestLen = -1
  const consider = (module, linkTo) => {
    if (!linkTo) return
    if (pathname === linkTo || pathname.startsWith(linkTo + "/")) {
      if (linkTo.length > bestLen) {
        bestLen = linkTo.length
        best = module
      }
    }
  }
  const walk = (node, module) => {
    consider(module, node?.linkTo)
    ;(node?.submenus || []).forEach(child => walk(child, module))
  }
  ;(modules || []).forEach(m => walk(m, m))
  return best
}

// Trail of ancestor GROUP nodes from a module down to the leaf whose linkTo
// matches the pathname, so the sidebar can open at the right drill-down level.
// Returns the array of group nodes (excluding the leaf), or [] if none matches.
const findTrail = (node, pathname) => {
  for (const child of node?.submenus || []) {
    const hasKids = (child?.submenus || []).length > 0
    if (!hasKids && child?.linkTo === pathname) return []
    if (hasKids) {
      const sub = findTrail(child, pathname)
      if (sub) return [child, ...sub]
    }
  }
  return null
}

// Single-submenu collapse: a node with exactly ONE child collapses to that child
// (recursively). So a module/group with a single submenu links straight to its only
// page instead of showing a redundant drill level. Returns the effective target node.
const collapseSingle = node => {
  let n = node
  let guard = 0
  while (n && (n.submenus || []).length === 1 && guard++ < 20) n = n.submenus[0]
  return n
}
const childCount = node => (node?.submenus || []).length

const SidebarContent = props => {
  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const { loggedUser } = useSelector(LoginProperties)
  const navigate = useNavigate()

  const [menuItems, setMenuItems] = useState([])
  // Drill-down position within the active module (stack of group nodes).
  const [navStack, setNavStack] = useState([])
  console.log("allmenucheck", menuItems)

  useEffect(() => {
    const rearrangeMenu = () => {
      if (!Array.isArray(loggedUser?.smenu)) return

      const updatedMenu = [...loggedUser.smenu] // Clone the menu to avoid mutating the original state

      // Find the 'Finance' item
      const financeItem = updatedMenu.find(item => item?.label === "Finance")
      const financeIndex = updatedMenu.indexOf(financeItem)

      // Find the 'User Management' item
      // const userManagementItem = updatedMenu.find(
      //   item => item?.label === "User Management"
      // )
      // const userManagementIndex = updatedMenu.indexOf(userManagementItem)

      if (financeItem) {
        // Remove both 'Finance' and 'User Management' from the original array
        updatedMenu.splice(financeIndex, 1)
        // updatedMenu.splice(
        //   userManagementIndex > financeIndex
        //     ? userManagementIndex - 1
        //     : userManagementIndex,
        //   1
        // )

        // Add 'Finance' and then 'User Management' at the end
        updatedMenu.push(financeItem)
        // updatedMenu.push(userManagementItem)

        setMenuItems(updatedMenu)
      }
    }

    if (loggedUser) {
      setMenuItems(loggedUser?.smenu)
      rearrangeMenu()
    }
  }, [loggedUser])

  // useEffect(() => {
  //   const rearrangeMenu = () => {
  //     if (!Array.isArray(loggedUser?.smenu)) return
  //     const updatedMenu = loggedUser?.smenu
  //     const financeItem = updatedMenu.find(item => item?.label === "Finance")
  //     if (financeItem) {
  //       // Remove 'Finance' from the original array
  //       const index = updatedMenu.indexOf(financeItem)
  //       updatedMenu.splice(index, 1)
  //       // Add 'Finance' to the end
  //       updatedMenu.push(financeItem)
  //       setMenuItems(updatedMenu)
  //     }
  //   }
  //   if (loggedUser) {
  //     setMenuItems(loggedUser?.smenu)
  //     rearrangeMenu()
  //   }
  // }, [loggedUser])

  // const ref = useRef();
  const activateParentDropdown = useCallback(item => {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      // scrollElement(item);
      return false
    }
    // scrollElement(item);
    return false
  }, [])

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i]
      const parent = items[i].parentElement

      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show")
        }

        parent.classList.remove("mm-active")
        const parent2 = parent.parentElement

        if (parent2) {
          parent2.classList.remove("mm-show")

          const parent3 = parent2.parentElement
          if (parent3) {
            parent3.classList.remove("mm-active") // li
            parent3.childNodes[0].classList.remove("mm-active")

            const parent4 = parent3.parentElement // ul
            if (parent4) {
              parent4.classList.remove("mm-show") // ul
              const parent5 = parent4.parentElement
              if (parent5) {
                parent5.classList.remove("mm-show") // li
                parent5.childNodes[0].classList.remove("mm-active") // a tag
              }
            }
          }
        }
      }
    }
  }

  const path = useLocation()
  const activeMenu = useCallback(() => {
    const pathName = path.pathname
    let matchingMenuItem = null
    const ul = document.getElementById("side-menu")
    const items = ul.getElementsByTagName("a")
    removeActivation(items)

    for (let i = 0; i < items.length; ++i) {
      // if (pathName === items[i].pathname) {
      if (pathName.includes(items[i].pathname)) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  }, [path.pathname, activateParentDropdown])

  // useEffect(() => {
  //   ref.current.recalculate();
  // }, []);

  useEffect(() => {
    const menu = new MetisMenu("#side-menu")
    activeMenu()
    return () => {
      menu.dispose()
    }
  }, [menuItems, activeMenu])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
    // activeMenu()
  }, [path.pathname])

  // Open the drill-down at the level matching the current route (and reset it
  // when the route/module changes). Manual drilling doesn't change the route, so
  // it isn't clobbered by this effect.
  useEffect(() => {
    const mod = findActiveModule(menuItems, path.pathname)
    setNavStack(mod ? findTrail(mod, path.pathname) || [] : [])
  }, [path.pathname, menuItems])

  // function scrollElement(item) {
  //   if (item) {
  //     const currentPosition = item.offsetTop;
  //     if (currentPosition > window.innerHeight) {
  //       ref.current.getScrollElement().scrollTop = currentPosition - 300;
  //     }
  //   }
  // }

  const iconMap = {
    dashImg: DashboardIcon,
    projectImg: ProjectManagementIcon,
    estimateImg: EstimateIcon,
    productMasterImg: ProductMasterIcon,
    procureImg: ProcurementIcon,
    hrmsImg: HrmsIcon,
    settingsImg: SettingsIcon,
    financeImg: FinanceIcon,
  }

  const activeModule = findActiveModule(menuItems, path.pathname)
  const ModuleIcon = (activeModule && iconMap[activeModule.icon]) || EstimateIcon

  // "Settings" is no longer a top-level module — its groups are surfaced under the
  // Administration section instead.
  const settingsModule = (menuItems || []).find(m => m?.label === "Settings")
  // "Masters" is dropped here: its still-needed pages (State, Country, Payment Mode)
  // moved into Administration > Application as tabs; the rest are retired.
  const adminGroups = (settingsModule?.submenus || []).filter(g => g?.label !== "Masters")

  // The node whose children are currently shown: the deepest drilled-into group,
  // or the module root when the stack is empty.
  const currentNode = navStack.length
    ? navStack[navStack.length - 1]
    : activeModule
  // Show the drill-down view when inside a module with MORE THAN ONE submenu, or
  // when drilled into any group. A single-submenu module links straight to its only
  // page (no drill level), so it never triggers the drill view on its own.
  const inDrill =
    navStack.length > 0 ||
    (activeModule && (activeModule.submenus || []).length > 1)
  const drillInto = node => setNavStack(s => [...s, node])
  const drillBack = () => {
    if (navStack.length) setNavStack(s => s.slice(0, -1))
    else navigate("/dashboard")
  }
  // Exit the whole drill in one click (skip clicking back level by level) → main menu.
  const drillExit = e => {
    e.stopPropagation()
    setNavStack([])
    navigate("/dashboard")
  }
  const canAccessLeaf = id =>
    loggedUser?.permission?.some(p => p?.id === id && p?.is_menu == 1)

  return (
    <React.Fragment>
      <style>{`
        /* Menu text: theme-aware (adapts to light/dark sidebar), blue on hover/active */
        #sidebar-menu #side-menu li a { color: var(--bs-sidebar-menu-item-color, #383838) !important; font-weight: 500; }
        #sidebar-menu #side-menu li a:hover,
        #sidebar-menu #side-menu li a.active,
        #sidebar-menu #side-menu li a.mm-active { color: var(--accent-clr) !important; }
        #sidebar-menu #side-menu li a:hover svg [stroke] { stroke: var(--accent-clr); }
        /* Administration uil icons: blue like the module icons, sized to match the SVGs */
        #sidebar-menu #side-menu li a .admin-uil {
          color: var(--accent-clr) !important; font-size: 20px; line-height: 1;
          display: inline-flex; align-items: center; justify-content: center; min-width: 24px;
        }
        #sidebar-menu #side-menu li a:hover .admin-uil,
        #sidebar-menu #side-menu li a.active .admin-uil,
        #sidebar-menu #side-menu li a.mm-active .admin-uil { color: var(--accent-clr) !important; }
        /* Separator before the Administration block (visible even when collapsed) */
        #sidebar-menu #side-menu li.admin-divider {
          border-top: 1px solid #e5e7eb; margin: 12px 16px; height: 0; padding: 0;
        }
        /* Drill-down "back" control — clean theme-blue pill, not a menu title */
        #sidebar-menu #side-menu li.modnav-back { margin-bottom: 6px; }
        #sidebar-menu #side-menu li.modnav-back a {
          cursor: pointer; margin: 6px 12px; padding: 9px 12px;
          background: var(--menu-avtive); border-radius: 10px;
          /* same typography as the .menu-title (e.g. ADMINISTRATION) */
          color: var(--accent-clr) !important; font-weight: 900;
          font-size: 11px; text-transform: uppercase; letter-spacing: .55px;
        }
        #sidebar-menu #side-menu li.modnav-back a:hover { background: var(--select-hover); color: var(--accent-clr) !important; }
        #sidebar-menu #side-menu li.modnav-back a .modnav-back-text { font-weight: 900; }
        #sidebar-menu #side-menu li.modnav-back .modnav-back-arrow { font-size: 14px; line-height: 1; margin-right: 8px; }
        /* Exit-to-main-menu cross, pinned right of the back pill */
        #sidebar-menu #side-menu li.modnav-back a .modnav-exit {
          margin-left: auto; font-size: 18px; line-height: 1; font-weight: 700;
          width: 18px; height: 18px; display: inline-flex; align-items: center; justify-content: center;
          border-radius: 5px; opacity: .7;
        }
        #sidebar-menu #side-menu li.modnav-back a .modnav-exit:hover { opacity: 1; background: var(--select-hover); }
        /* Smaller sidebar icons (module SVGs + Administration uil icons) */
        #sidebar-menu #side-menu li a svg.side-menu-icon {
          width: 18px !important; height: 18px !important; background-size: 18px 18px !important;
        }
        /* keep every menu icon on one vertical line: module SVGs + uil icons share .side-menu-icon,
           so give them an identical centered box + margin (overrides the mixed me-3 / widths). */
        #sidebar-menu #side-menu li a .side-menu-icon {
          min-width: 24px !important; margin-right: 12px !important;
          display: inline-flex !important; align-items: center !important; justify-content: center !important;
        }
        #sidebar-menu #side-menu li a .admin-uil { font-size: 18px !important; }
        /* Comfortable, even menu spacing (matches the Administration items) */
        #sidebar-menu #side-menu li a { padding-top: 7px !important; padding-bottom: 7px !important; }
        #sidebar-menu #side-menu li { margin-bottom: 2px !important; }
        #sidebar-menu #side-menu li a .sidebar-menus-li { line-height: 1.2; }
        /* Collapsed (icon-only) sidebar: the theme centers svg icons + hides <span>, but
           our Administration/Developer links use <i> icons + a .sidebar-menus-li <div>.
           Hide that label and center the <i> icon so they collapse cleanly like modules;
           reveal the label on hover (matching the theme's expand-on-hover).
           NOTE: key ONLY on data-sidebar-size=sm (the real collapse signal, width 70px).
           The theme sometimes leaves a stale vertical-collpsed class on body after
           re-maximizing while data-sidebar-size flips back to lg -- keying on that class
           hid the labels on a fully-expanded (250px) sidebar (the invisible-text bug). */
        body[data-sidebar-size="sm"] #sidebar-menu #side-menu > li > a .sidebar-menus-li { display: none !important; }
        body[data-sidebar-size="sm"] #sidebar-menu #side-menu > li > a .side-menu-icon {
          min-width: 50px !important; margin-right: 0 !important;
        }
        body[data-sidebar-size="sm"] #sidebar-menu #side-menu > li:hover > a .sidebar-menus-li { display: flex !important; }
      `}</style>
      <SimpleBar style={{ maxHeight: "100%" }}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            {/* <li className="menu-title">{props.t("Menu")} </li> */}
            {inDrill ? (
              /* Per-module drill-down nav: groups drill into the next level,
                 leaves navigate. The back arrow climbs one level, and exits to
                 the module list at the root. */
              <>
                <li className="modnav-back">
                  <a
                    role="button"
                    onClick={drillBack}
                    className="d-flex align-items-center"
                  >
                    <span className="modnav-back-arrow">&larr;</span>
                    <span className="modnav-back-text">
                      {props.t(currentNode?.label)}
                    </span>
                    <span
                      role="button"
                      className="modnav-exit"
                      title={props.t("Back to main menu")}
                      onClick={drillExit}
                    >
                      &times;
                    </span>
                  </a>
                </li>
                {(currentNode?.submenus || []).map(child => {
                  // >1 children → drill deeper; 0 or 1 child → link straight to the
                  // (collapsed) target page (single-submenu groups don't drill).
                  if (childCount(child) > 1) {
                    return (
                      <li key={`nav_${child.id}`}>
                        <a
                          role="button"
                          className="waves-effect d-flex align-items-center"
                          style={{ cursor: "pointer" }}
                          onClick={() => drillInto(child)}
                        >
                          <ModuleIcon className="me-3 side-menu-icon" />
                          <div className="d-flex align-items-center sidebar-menus-li">
                            {props.t(child.label)}
                          </div>
                          <span style={{ marginLeft: "auto", color: "#9aa3b2", fontSize: 18 }}>
                            &rsaquo;
                          </span>
                        </a>
                      </li>
                    )
                  }
                  const target = collapseSingle(child)
                  if (childCount(child) === 0 && !canAccessLeaf(child.id)) return null
                  return target.linkTo ? (
                    <li key={`nav_${child.id}`}>
                      <Link to={target.linkTo} className="waves-effect d-flex">
                        <ModuleIcon className="me-3 side-menu-icon" />
                        <div className="d-flex align-items-center sidebar-menus-li">
                          {props.t(child.label)}
                        </div>
                      </Link>
                    </li>
                  ) : null
                })}
              </>
            ) : !loggedUser?.smenu?.length ? (
              <SkeletonLoading />
            ) : (
              <>
                {/* MODULES list — shown to everyone including developer (full-access,
                    same as admin). Each item is still permission-gated below. */}
                <>
                <li className="menu-title">{props.t("MODULES")}</li>
                {menuItems
                  ?.filter(dt => dt?.label !== "Settings")
                  .map((dt, i) => {
                  const IconComponent = iconMap[dt?.icon] || EstimateIcon
                  return (
                    <li key={`side_${i}`}>
                      {loggedUser?.permission?.some(
                        permissionItem =>
                          permissionItem?.id === dt.id &&
                          permissionItem?.is_menu == 1
                      ) && (
                        <Link to={childCount(dt) === 1 ? collapseSingle(dt).linkTo : dt?.linkTo} className="waves-effect  d-flex">
                          <IconComponent className="me-3 side-menu-icon" />

                          <div className="d-flex align-items-center sidebar-menus-li">
                            {props.t(`${dt?.label}`)}
                          </div>
                        </Link>
                      )}
                    </li>
                  )
                })}
                </>
              </>
            )}
            {/* Administration + Logout: always visible, at every menu level
                (even inside a module's secondary nav). */}
            {loggedUser?.company_context?.is_super_admin && (
              <>
                {/* Separator before Administration — stays visible in the collapsed
                    (icon-only / mobile) menu where the ADMINISTRATION title is hidden. */}
                <li className="admin-divider" aria-hidden="true"></li>
                <li className="menu-title">OPERATIONS</li>
                <li>
                  <Link to="/company-management" className="waves-effect d-flex">
                    <i className="uil-building me-3 side-menu-icon admin-uil" />
                    <div className="d-flex align-items-center sidebar-menus-li">Group / Company</div>
                  </Link>
                </li>
                <li>
                  <Link to="/admin/application" className="waves-effect d-flex">
                    <i className="uil-apps me-3 side-menu-icon admin-uil" />
                    <div className="d-flex align-items-center sidebar-menus-li">Application</div>
                  </Link>
                </li>
                {/* Camp Management lives here (Administration), not in the company-scoped
                    Modules list, because camps are global (cross-company) accommodations. */}
                <li>
                  <Link to="/camp-dashboard" className="waves-effect d-flex">
                    <i className="uil-bed me-3 side-menu-icon admin-uil" />
                    <div className="d-flex align-items-center sidebar-menus-li">Camps</div>
                  </Link>
                </li>
                {/* Fleet — global vehicle master (owner = company). Only when the Fleet
                    module is enabled in Developer → Application Settings. */}
                {loggedUser?.settings?.enable_fleet_module ? (
                  <li>
                    <Link to="/fleet-dashboard" className="waves-effect d-flex">
                      <i className="uil-car me-3 side-menu-icon admin-uil" />
                      <div className="d-flex align-items-center sidebar-menus-li">Fleet</div>
                    </Link>
                  </li>
                ) : null}
                <li>
                  <Link to="/admin/sponsors" className="waves-effect d-flex">
                    <i className="uil-user-square me-3 side-menu-icon admin-uil" />
                    <div className="d-flex align-items-center sidebar-menus-li">Sponsors</div>
                  </Link>
                </li>
                {/* Settings groups moved here from the removed Settings module.
                    "User Management" opens the tabbed page (User Access / Role Access)
                    directly — no submenu drill-in. Others still drill in. */}
                {adminGroups.map(group =>
                  group.label === "User Management" ? (
                    <li key={`admg_${group.id}`}>
                      <Link to="/user-management" className="waves-effect d-flex">
                        <i className="uil-users-alt me-3 side-menu-icon admin-uil" />
                        <div className="d-flex align-items-center sidebar-menus-li">
                          {props.t(group.label)}
                        </div>
                      </Link>
                    </li>
                  ) : (
                    <li key={`admg_${group.id}`}>
                      <a
                        role="button"
                        className="waves-effect d-flex align-items-center"
                        style={{ cursor: "pointer" }}
                        onClick={() => drillInto(group)}
                      >
                        <i className="uil-cog me-3 side-menu-icon admin-uil" />
                        <div className="d-flex align-items-center sidebar-menus-li">
                          {props.t(group.label)}
                        </div>
                        <span style={{ marginLeft: "auto", color: "#9aa3b2", fontSize: 18 }}>
                          &rsaquo;
                        </span>
                      </a>
                    </li>
                  )
                )}
              </>
            )}
            {/* Developer hub: hidden, vendor-only. Invisible to admins/super-admins. */}
            {loggedUser?.company_context?.is_developer && (
              <>
                <li className="admin-divider" aria-hidden="true"></li>
                <li className="menu-title">DEVELOPER</li>
                <li>
                  <Link to="/developer" className="waves-effect d-flex">
                    <i className="uil-processor me-3 side-menu-icon admin-uil" />
                    <div className="d-flex align-items-center sidebar-menus-li">Developer Settings</div>
                  </Link>
                </li>
              </>
            )}
            {loggedUser?.smenu && (
              <li>
                <Link to={"/logout"} className="waves-effect  d-flex">
                  <LogoutIcon className={`me-3 side-menu-icon`} />
                  <div className="d-flex align-items-center">Logout</div>
                </Link>
              </li>
            )}
            {/* <li className="menu-title">Pages</li>
            <li>
              <Link to="/#" className="has-arrow waves-effect d-flex align-items-center">
                <i className="uil-user-circle"></i>
                <span>{props.t("Authentication")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/pages-login">{props.t("Login")}</Link>
                </li>
                <li>
                  <Link to="/pages-register">{props.t("Register")}</Link>
                </li>
                <li>
                  <Link to="/page-recoverpw">
                    {props.t("Recover Password")}
                  </Link>
                </li>
                <li>
                  <Link to="/auth-lock-screen">{props.t("Lock Screen")}</Link>
                </li>
              </ul>
            </li> */}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
